import { render, staticRenderFns } from "./edi-page.vue?vue&type=template&id=385b1d50"
import script from "./edi-page.vue?vue&type=script&lang=js"
export * from "./edi-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385b1d50')) {
      api.createRecord('385b1d50', component.options)
    } else {
      api.reload('385b1d50', component.options)
    }
    module.hot.accept("./edi-page.vue?vue&type=template&id=385b1d50", function () {
      api.rerender('385b1d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/EDI/edi-page.vue"
export default component.exports